<template lang="pug">
  .challenge(:class="{ 'challenge--completed': isChallengeCompleted }")
    .challenge__left
      .challenge__block
        .challenge__name(v-html="calculatedName")
      .challenge__bar
        .challenge__numbers(v-html="calculatedNumbers")
        .challenge__progress
          .challenge__progress__current(:style="{ width: progressWidth }")
    .challenge__right(v-if="prizesArray.length")
      Swiper.challenge__slider(:ref="swiper_ref" v-click-outside="hidePrizeName" :options="swiper_settings" @slideChange="onSlideChange")
        SwiperSlide(v-for="(offer, i) in prizesArray" :key="i" @click.native="onSlideClick(i)")
          img.challenge__image(:src="getPrizeImage(offer)")
          .challenge__image__name(:class="{ 'challenge__image__name--active': currentlyShownPrizeName === i }" v-html="getPrizeName(offer)")
      SwiperArrows(:activeSlide="activeSlide" :totalSlides="prizesArray.length" @changeNext="slide('next')", @changePrev="slide('prev')")
</template>

<script>
import ClickOutside from "vue-click-outside"

import SwiperArrows from "./SwiperArrows";
import SwiperMixin from "@/assets/js/SwiperMixin.js";
import ObjectCheckMixin from "@/assets/js/ObjectCheckMixin.js";

import MobileDetectionMixin from "@chronos/frontend-base/src/mixins/mobile_detection/MobileDetectionMixinNew";

export default {
  name: "Challenge",
  components: {
    SwiperArrows,
  },
  directives: {
    ClickOutside,
  },
  mixins: [SwiperMixin, ObjectCheckMixin, MobileDetectionMixin],
  props: {
    data: {
      type: Object,
      default: null,
    },
    offersList: {
      type: Object,
      default: null,
    },
    frontendSettings: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      swiper_ref: "challenge",
      currentlyShownPrizeName: null,
    }
  },
  computed: {
    arePrizesExist() {
      return this.isObject(this.data.rewards);
    },
    calculatedName() {
      return this.frontendSettings[this.data.name] ?? this.data.name;
    },
    prizesArray() {
      const array = [];
      if (this.arePrizesExist) {
        const keys = Object.keys(this.data.rewards);
        keys.forEach((key) => {
          for (let i = 0; i < this.data.rewards[key]; i++) array.push(key);
        })
      }
      return array;
    },
    currentCounter() {
      const counter = this.data.counters[this.data.current_counter];

      return counter ?? 0;
    },
    isChallengeCompleted() {
      return this.currentCounter >= this.data.target_amount;
    },
    calculatedNumbers() {
      return this.currentCounter + " / " + this.data.target_amount;
    },
    progressWidth() {
      if (this.isChallengeCompleted) {
        return "100%";
      }

      return this.currentCounter / this.data.target_amount * 100 + "%";
    },
  },
  methods: {
    getPrizeImage(offer) {
      return this.offersList[offer]?.image;
    },
    getPrizeName(offer) {
      return this.offersList[offer]?.name;
    },
    onSlideClick(i) {
      if (this.isTabletWideMax) {
        if (this.currentlyShownPrizeName === i) {
          this.currentlyShownPrizeName = null;
          return;
        }

        this.currentlyShownPrizeName = i;
      }
    },
    hidePrizeName() {
      this.currentlyShownPrizeName = null;
    },
  },
}
</script>